<div class="home-desktop">
  <sports-component></sports-component>
</div>
<div class="home-mobile">
  <!-- E-Mail Verifiation -->
  <div class="verification-container" *ngIf="!this._UserHelper.emailIsVerified">
    <div class="icon">
      <image-loader-utils url="mail" extraClasses="slidermenusvg"></image-loader-utils>
    </div>

    <div class="text">
      {{ 'b3000_email_verification_text' | t }}
      <b (click)="reSendConfirmation()">
        <u>{{ 'b3000_email_verification_text2' | t }}</u>
      </b>
    </div>
  </div>
  <!-- E-Mail Verifiation -->

  <!--  0 => Not Checked-->
  <!--  1 => Pre Checked-->
  <!--  2 => Checked-->

  <!-- Insic Not Checked -->
  <div class="verification-container" *ngIf="_UiHelper.insicStatus == 0 || _UiHelper.insicStatus == -1 || _UiHelper.insicStatus == -2" (click)="showTabsMenuMobile(2)">
    <div class="icon">
      <image-loader-utils url="info-user" extraClasses="slidermenusvg"></image-loader-utils>
    </div>
    <div class="text" *ngIf="_UiHelper.insicStatus == 0 || _UiHelper.insicStatus == -1">
      {{ 'b3000_insic_status_not_checked1' | t }}
      <b>
        {{ 'b3000_insic_status_not_checked_link1' | t }} <u>{{ 'b3000_insic_status_not_checked_link_21' | t }}</u>
      </b>
    </div>
    <div class="text" *ngIf="_UiHelper.insicStatus == -2">
      {{ 'b3000_insic_status_not_checked' | t }}
      <b>
        {{ 'b3000_insic_status_not_checked_link' | t }} <u>{{ 'b3000_insic_status_not_checked_link_2' | t }}</u>
      </b>
    </div>
  </div>
  <!-- Insic Not Checked -->

  <!-- Insic Pre Checked -->
  <div class="verification-container" *ngIf="_UiHelper.insicStatus == 1" (click)="showTabsMenuMobile(2)">
    <div class="text">
      {{ 'b3000_insic_status_pre_checked' | t }}
      <div class="mt-8">
        <b>
          {{ 'b3000_insic_status_pre_checked_link' | t }}
        </b>
      </div>
    </div>
  </div>
  <!-- Insic Pre Checked -->

  <!--Slider-->
  <slider [data]="this._DataHelper.homeSliderData" [slideShow]="true" [slideShowTime]="5" [heightMultiper]="1" [objectFit]="'cover'" [isLive]="false"></slider>
  <!--Sports-->

  <div class="story-slider-row">
    <div class="story-slider-box">
      <div class="story-slider-item" [routerLink]="['/fav']" *ngIf="this._UiHelper.favPreMatches.length > 0">
        <div class="story-slider-icon-count">
          <image-loader-utils url="star" extraClasses="story-slider-icon favorited"></image-loader-utils>
          <div class="story-slider-count">
            {{ this._UiHelper.favPreMatches.length }}
          </div>
        </div>
        <div class="story-slider-sport-name">{{ 'Favourites' | t }}</div>
      </div>
      <div
        class="story-slider-item"
        *ngFor="let item of mainData; let i = index"
        [ngClass]="{ selected: item.SportId == selectedSportId }"
        (click)="getCountriesBySportsID(item, i)"
        [routerLink]="['/allsports/' + item.SportId]">
        <div class="story-slider-icon-count">
          <image-loader-utils [url]="this.sportsSvgList[item.SportId]?.svgKey" extraClasses="slidermenusvg"></image-loader-utils>
        </div>
        <div class="story-slider-sport-name">{{ item.SportName }}</div>
      </div>
    </div>
  </div>

  <!--Highlights-->
  <div class="match-row-header highlights">{{ 'Highlights' | t }}</div>
  <prematch-component [oddMarketingValue]="oddMarketingB3000Value" [preMatchobservable]="this.preMatchobservable" [_selectedOdds]="this._selectedOdds"></prematch-component>
  <!--Promotions-->
  <div class="home-promotions">
    <div class="title">Weitere Highlights</div>
    <div class="sliderItem" *ngFor="let i of this._DataHelper.homeSliderData; let _k = index" (click)="goBanner(i)" style="margin-bottom: 10px">
      <img [style.width]="'100%'" src="{{ i.FileName }}" alt="" [style.object-fit]="objectFit" />
    </div>
  </div>
</div>
